import React, { useState } from "react";
import { IconButton, Popover, Stack } from "@mui/material";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import { HubIcon } from "../HubIcon";

const ToolbarButton = ({ icon, action, isActive, title }) => (
  <IconButton
    size="small"
    onClick={action}
    className={`toolbar-btn ${isActive ? "is-active" : ""}`}
    title={title}
  >
    <HubIcon icon={icon} size={14} />
  </IconButton>
);

const Divider = () => <div className="toolbar-divider" />;

const EditorToolbar = ({ editor, compact = false }) => {
  const [emojiAnchor, setEmojiAnchor] = useState(null);

  if (!editor) return null;

  const onSelectEmoji = (emoji) => {
    editor.chain().focus().insertContent(emoji.native).run();
    setEmojiAnchor(null);
  };

  const compactButtons = (
    <>
      <ToolbarButton
        icon="Bold"
        action={() => editor.chain().focus().toggleBold().run()}
        isActive={editor.isActive("bold")}
        title="Bold"
      />
      <ToolbarButton
        icon="Italic"
        action={() => editor.chain().focus().toggleItalic().run()}
        isActive={editor.isActive("italic")}
        title="Italic"
      />
      <ToolbarButton
        icon="Underline"
        action={() => editor.chain().focus().toggleUnderline().run()}
        isActive={editor.isActive("underline")}
        title="Underline"
      />
      <Divider />
      <ToolbarButton
        icon="Code"
        action={() => editor.chain().focus().toggleCode().run()}
        isActive={editor.isActive("code")}
        title="Inline Code"
      />
      <ToolbarButton
        icon="List"
        action={() => editor.chain().focus().toggleBulletList().run()}
        isActive={editor.isActive("bulletList")}
        title="Bullet List"
      />
      <ToolbarButton
        icon="Smile"
        action={(e) => setEmojiAnchor(e.currentTarget)}
        title="Emoji"
      />
    </>
  );

  const fullButtons = (
    <>
      <ToolbarButton
        icon="Bold"
        action={() => editor.chain().focus().toggleBold().run()}
        isActive={editor.isActive("bold")}
        title="Bold"
      />
      <ToolbarButton
        icon="Italic"
        action={() => editor.chain().focus().toggleItalic().run()}
        isActive={editor.isActive("italic")}
        title="Italic"
      />
      <ToolbarButton
        icon="Underline"
        action={() => editor.chain().focus().toggleUnderline().run()}
        isActive={editor.isActive("underline")}
        title="Underline"
      />
      <ToolbarButton
        icon="Minus"
        action={() => editor.chain().focus().toggleStrike().run()}
        isActive={editor.isActive("strike")}
        title="Strikethrough"
      />
      <Divider />
      <ToolbarButton
        icon="Type"
        action={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
        isActive={editor.isActive("heading", { level: 1 })}
        title="Heading 1"
      />
      <ToolbarButton
        icon="Hash"
        action={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
        isActive={editor.isActive("heading", { level: 2 })}
        title="Heading 2"
      />
      <Divider />
      <ToolbarButton
        icon="List"
        action={() => editor.chain().focus().toggleBulletList().run()}
        isActive={editor.isActive("bulletList")}
        title="Bullet List"
      />
      <ToolbarButton
        icon="Hash"
        action={() => editor.chain().focus().toggleOrderedList().run()}
        isActive={editor.isActive("orderedList")}
        title="Ordered List"
      />
      <Divider />
      <ToolbarButton
        icon="MessageSquare"
        action={() => editor.chain().focus().toggleBlockquote().run()}
        isActive={editor.isActive("blockquote")}
        title="Blockquote"
      />
      <ToolbarButton
        icon="Code"
        action={() => editor.chain().focus().toggleCode().run()}
        isActive={editor.isActive("code")}
        title="Inline Code"
      />
      <ToolbarButton
        icon="Terminal"
        action={() => editor.chain().focus().toggleCodeBlock().run()}
        isActive={editor.isActive("codeBlock")}
        title="Code Block"
      />
      <Divider />
      <ToolbarButton
        icon="Link"
        action={() => {
          const url = window.prompt("URL");
          if (url) editor.chain().focus().setLink({ href: url }).run();
        }}
        isActive={editor.isActive("link")}
        title="Link"
      />
      <ToolbarButton
        icon="Image"
        action={() => {
          const url = window.prompt("Image URL");
          if (url) editor.chain().focus().setImage({ src: url }).run();
        }}
        title="Image"
      />
      <ToolbarButton
        icon="Minus"
        action={() => editor.chain().focus().setHorizontalRule().run()}
        title="Divider"
      />
      <Divider />
      <ToolbarButton
        icon="Smile"
        action={(e) => setEmojiAnchor(e.currentTarget)}
        title="Emoji"
      />
    </>
  );

  return (
    <>
      {compact ? compactButtons : fullButtons}
      <Popover
        open={!!emojiAnchor}
        anchorEl={emojiAnchor}
        onClose={() => setEmojiAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Picker data={data} onEmojiSelect={onSelectEmoji} theme="light" previewPosition="none" skinTonePosition="none" />
      </Popover>
    </>
  );
};

export default EditorToolbar;
